import { ref } from 'vue'
import type { Router } from 'vue-router'
import type { Store } from 'vuex'
import { performLogout } from '@/composables/useAutoLogout'

// Aviso de "sua sessão foi encerrada" (ForceLogoutWarningModal). Quem dispara é o batimento da
// sessão (useSessionTracking) quando o WootDash recusa o token — sessão revogada em Sessões.
// Tipos: session = revogada (Ctrl+Shift+S, logout geral); expired = o token venceu sem renovar (aba parada ou
// notebook dormindo além da validade); account = conta desativada. Em session/expired o modal oferece "Continuar
// logado" com a senha: entra de novo sem sair da tela (ForceLogoutWarningModal).
const WARNING_SECONDS = 30

export const showForceLogout = ref(false)
export const forceLogoutSecondsLeft = ref(WARNING_SECONDS)
export const forceLogoutKind = ref<'account' | 'session' | 'expired'>('session')
/** Quem revogou (Sessões dos agentes, Ctrl+Shift+S) — vazio quando foi o batimento que percebeu. */
export const forceLogoutBy = ref('')

let countdownTimer: ReturnType<typeof setInterval> | null = null

function stopCountdown() {
  if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null }
}

export function armForceLogoutWarning(kind: 'account' | 'session' | 'expired', store: Store<any>, router: Router, by = ''): void {
  if (showForceLogout.value) return
  forceLogoutKind.value = kind
  forceLogoutBy.value = by
  showForceLogout.value = true
  forceLogoutSecondsLeft.value = WARNING_SECONDS
  stopCountdown()
  countdownTimer = setInterval(() => {
    forceLogoutSecondsLeft.value -= 1
    if (forceLogoutSecondsLeft.value <= 0) logoutNowForced(store, router)
  }, 1_000)
}

export function resetForceLogout(): void {
  showForceLogout.value = false
  forceLogoutSecondsLeft.value = WARNING_SECONDS
  forceLogoutKind.value = 'session'
  forceLogoutBy.value = ''
  stopCountdown()
}

/** Token revogado não tem volta: "continuar" também sai (o modal pode manter o botão por hábito). */
export async function continueForcedSession(store: Store<any>, router?: Router) {
  if (router) await logoutNowForced(store, router)
  else resetForceLogout()
}

export async function logoutNowForced(store: Store<any>, router: Router) {
  showForceLogout.value = false
  stopCountdown()
  await performLogout(store, router)
}

/** "Continuar logado": a pessoa começou a digitar a senha — a contagem para (senão desloga no meio). */
export function pauseForceLogoutCountdown(): void {
  stopCountdown()
}
